const getters = {
  token: (state) => state.user.token ?? '',
  userData: (state) => state.user.userData ?? {},
  roles: (state) => state.user?.userData?.roles ?? [],
};
export default getters;

